var map = {
	"./type-1.png": "f3f0",
	"./type-2.png": "255e",
	"./type-3.png": "d50d",
	"./type-4.png": "a8e4",
	"./type-5.png": "002c",
	"./type-6.png": "05a5",
	"./type-7.png": "e377",
	"./type-8.png": "c0bc",
	"./type-9.png": "2361"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d468";